module.exports = __webpack_public_path__ + "static/media/decor-item.8c8aeace.svg";